module.exports = __webpack_public_path__ + "static/media/infiltration_movement_example.7a9eb0b7.jpg";